/**
 * AAA IDP LicenceScans component
 * 
 */
import React from 'react';
import { IMAGE_PATH_PREFIX } from '../../data/Data';
import './LicenceScans.scss';
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
export default function LicenceScans() {
  return /*#__PURE__*/_jsxs("div", {
    className: "LicenceScans",
    children: [/*#__PURE__*/_jsx("p", {
      children: "As part of the application we require you to upload a scan or photo of the front and back of your current Australian driver licence."
    }), /*#__PURE__*/_jsxs("div", {
      className: "examples",
      children: [/*#__PURE__*/_jsxs("div", {
        children: [/*#__PURE__*/_jsx("img", {
          className: "licence-sample",
          src: `${IMAGE_PATH_PREFIX}licence-front.png`,
          alt: "Sample licence front"
        }), /*#__PURE__*/_jsxs("p", {
          children: ["Licence front", /*#__PURE__*/_jsx("sup", {
            children: "*"
          })]
        })]
      }), /*#__PURE__*/_jsxs("div", {
        children: [/*#__PURE__*/_jsx("img", {
          className: "licence-sample",
          src: `${IMAGE_PATH_PREFIX}licence-back.png`,
          alt: "Sample licence front"
        }), /*#__PURE__*/_jsxs("p", {
          children: ["Licence back", /*#__PURE__*/_jsx("sup", {
            children: "*"
          })]
        })]
      })]
    }), /*#__PURE__*/_jsx("p", {
      className: "title",
      children: "Photo requirements: "
    }), /*#__PURE__*/_jsx("ul", {
      children: /*#__PURE__*/_jsx("li", {
        children: "Must be a clear and readable scan of the front and back of the licence."
      })
    })]
  });
}